import classes from './CommonButton.module.css'

const CommonButton = ({text, onClick, className}) => {
    return(
        <button className={`${classes.wrapper} ${className}`} onClick={onClick}>
            {text}
        </button>
    )
}

export default CommonButton